import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { UserService } from '../services/user.service';
import * as moment from 'moment';
import { MatAutocompleteSelectedEvent } from '@angular/material';
import { ClientOrderService } from '../clientorderreport/clientorderreport.service';
import { ClearJunctionService } from '../services/clearjunction.service';
const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-editclearJtransactions',
    templateUrl: './editclearJtransactions.component.html',
    styleUrls: ['./editclearJtransactions.component.css']
})
export class EditClearJTransactions {
    element: any;
    editForm: any;
    constructor(
        public dialogRef: MatDialogRef<EditClearJTransactions>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private userService: UserService,
        private notifSer: NotificationsService,
        public fb: FormBuilder,
        public clearJService: ClearJunctionService
    ) {
        this.element = data;
    }
    ngOnInit(): void {
        this.editForm = this.fb.group({
            _id: [''],
            orderReference: ['', Validators.required],
            clientOrder: ['', Validators.required],
            currency: ['', Validators.required],
            amount: ['', Validators.required],
            description: ['', Validators.required],
        });
        this.displayEditData();
    }
    displayEditData(): void {
        this.editForm.controls["orderReference"].patchValue(this.element.orderReference);
        this.editForm.controls["clientOrder"].patchValue(this.element.clientOrder);
        this.editForm.controls["currency"].patchValue(this.element.currency);
        this.editForm.controls["amount"].patchValue(this.element.amount);
    }
    saveClearJTransactions() {
        const { notif } = defaults;
        this.userService.csrf().subscribe(success => {
            this.editForm.value['_csrf'] = success['_csrf'];
            this.editForm.value['_id'] = this.element._id;
            this.clearJService.saveClearJunctionTransactions(this.editForm.value).subscribe(response => {
                if (response.data) {
                    this.notifSer.success('Success', response.message, notif)
                    this.dialogRef.close();
                }
                else this.notifSer.error('Error', response.message, notif);
            }, err => this.notifSer.error('Error', err.error.message))
        })
    }
}


// WEBPACK FOOTER //
// ./src/app/editclearJtransactions/editclearJtransactions.component.ts